import type { DataFetcher, QACheckResult } from './type/qa-engine';
import type { Rule } from './type/rule';
import { QaCheckError, QaCheckErrorCode, QaCheckFormattedError } from './utils/error';
import { interpolateErrorMessage } from './utils/interpolate-error-message';
import { validateRuleWithData } from './utils/validate-rule-with-data';
export const createQaEngine = <Binding, Args, MetadataTypes>(rules: Rule<Binding>[], dataFetcher: DataFetcher<Binding, Args, MetadataTypes>) => {
  const evaluateRuleOnTaskState = (args: Args) => {
    const resultMappedToRule: {
      [ruleName: string]: QACheckResult<MetadataTypes>;
    } = {};
    for (const rule of rules) {
      const resolvedData = dataFetcher(rule.bindings, args);
      if (resolvedData instanceof QaCheckError && resolvedData.code === QaCheckErrorCode.missingFields) {
        continue;
      }
      if (resolvedData instanceof QaCheckError) {
        return new QaCheckFormattedError(resolvedData, rule);
      }
      const result = validateRuleWithData(resolvedData, rule);
      if (result instanceof QaCheckError) {
        return new QaCheckFormattedError(result, rule);
      }
      resultMappedToRule[rule.name] = {
        summarizedResult: result.every(({
          result
        }) => result),
        instanceResult: result,
        description: rule.description,
        errorMessage: interpolateErrorMessage(rule.errorMessage, resolvedData),
        name: rule.name
      };
    }
    return resultMappedToRule;
  };
  return {
    evaluateRuleOnTaskState
  };
};